import { Controller } from '@hotwired/stimulus';

import Commenter from '@/modules/commenter';
import Product from '@/modules/product';
import Voting from '@/modules/voting';

export default class extends Controller {
  connect() {
    new Voting({ voteableType: 'Comment', wrapper: '.comment__card' }).create();
    new Commenter().create();
    new Product().create();
  }
}
